import { FileForm } from '../../models/inputTypes/FileType';
import { findFileType } from './findFileType';

export const sortProjectFiles = (data: any[], title: string, ascending: boolean) => {
  switch (title) {
    case 'NAME':
      return data.sort((item1, item2) =>
        ascending ? item1.name.localeCompare(item2.name) : item2.name.localeCompare(item1.name),
      );
    case 'DATE':
      return data.sort((item1, item2) => {
        const key1 = new Date(item1.created_at);
        const key2 = new Date(item2.created_at);
        if (key1 < key2) return ascending ? -1 : 1;
        if (key1 > key2) return ascending ? 1 : -1;
        return 0;
      });
    case 'SIZE':
      return data.sort((item1, item2) => (ascending ? item1.size - item2.size : item2.size - item1.size));
    case 'TYPE':
      return data.sort((item1, item2) => {
        const key1 = findFileType(item1.name);
        const key2 = findFileType(item2.name);
        return ascending ? key2.localeCompare(key1) : key1.localeCompare(key2);
      });
  }
  return data;
};
